import React from 'react';
import { useTranslation } from 'react-i18next';
import WhyChooseUs from '../sections/WhyChooseUs';
import usePageMeta from '../hooks/usePageMeta';
import useLangPrefix from '../hooks/useLangPrefix';

function WhyChooseUsPage() {
  const { t } = useTranslation();
  const langPrefix = useLangPrefix();

  usePageMeta({
    title: `${t('whyChooseUs.heading')} | Marwa Hawshar`,
    description: t('whyChooseUs.subheading'),
    path: `${langPrefix}/why-choose-us`,
  });

  const differentiators = t('whyChooseUs.differentiators', { returnObjects: true });

  return (
    <>
      <h1 className="visually-hidden">{t('whyChooseUs.heading')}</h1>
      <WhyChooseUs />
      <section className="py-5 py-lg-6 bg-white">
        <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-8 text-center">
              <h2 className="h3 fw-semibold text-navy mb-3">{t('whyChooseUs.approachHeading')}</h2>
              <p className="text-muted mb-0">{t('whyChooseUs.approach')}</p>
            </div>
          </div>

          <div className="row justify-content-center mb-4">
            <div className="col-lg-8 text-center">
              <h2 className="h4 fw-semibold text-navy mb-0">{t('whyChooseUs.differentiatorsHeading')}</h2>
            </div>
          </div>
          <div className="row g-4">
            {Array.isArray(differentiators) &&
              differentiators.map((item, i) => (
                <div className="col-md-6" key={i}>
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body p-4">
                      <h3 className="h6 fw-semibold text-navy mb-3">{item.title}</h3>
                      <p className="card-text small text-muted mb-0">{item.description}</p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default WhyChooseUsPage;
